import {Component, Inject} from 'ng-metadata/core';
import {NewspapersService} from './newspapers.service';
import {STATE_NAMES} from "../primoExplore/primoExploreStates.module";
import {SearchFieldsService} from '../search/search.fields.service';
import {getVid} from '../appConfig/appConfigForward';
import {MediaQueries} from "../infra/mediaQueries.service";


@Component({
    selector: 'prm-newspapers-home',
    templateUrl: 'components/newspapers/newspapers-home.html',
})

export class PrmNewspapersHome{
    private vid = getVid();
    private firstTimeInLandingPage = true;

    constructor(private newspapersService: NewspapersService,
                @Inject('$stateParams') private $stateParams,
                @Inject('$state') private $state:angular.ui.IStateService,
                private searchFieldsService: SearchFieldsService,
                private mediaQueries: MediaQueries) {
        if (this.$stateParams['query']) {
            this.firstTimeInLandingPage = false;
        }
        else {
            this.newspapersService.cameFromSearch = false;
            this.newspapersService.cameFromFeaturedSearch = false;
            this.newspapersService.featuredTitle = '';
            this.newspapersService.featuredDescription = '';
        }
    }

    private displayFeaturedNewspapers() {
        return this.newspapersService.displayFeaturedNewspapers();
    }

    public get featuredNewspapers() {
        return this.newspapersService.featuredNewspapers;
    }

    private goToFeaturedNewspaper(index) {
       let featuredIssn = this.newspapersService.featuredNewspapers[index].issn.replace(/;$/, '');
        let params = {
                query: 'any,contains, ', //we can't send an empty query
                search_scope: 'featured',
                featured_scope: this.newspapersService.featuredNewspapers[index].name,
                vid: this.vid,
                offset: 0,
                facet: [],
                mfacet: [],
                pfilter: [],
                issn: featuredIssn
            };
            this.searchFieldsService.searchParams= params;
            this.newspapersService.cameFromFeaturedSearch = true;
            this.newspapersService.featuredTitle = this.newspapersService.featuredNewspapers[index].name;
            this.newspapersService.featuredDescription = this.newspapersService.featuredNewspapers[index].description;
            return this.$state.go(STATE_NAMES.NEWSPAPERS, params, {reload: true});
    }






}


// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/newspapersHome.directive.ts